import styled from 'styled-components/macro';

export default styled.div`
  height: 1px;
  margin: 5px 0;
  background-color: #282324;
`;
